import { AnyAction } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { State } from '~/Reducers'

export const START_FETCHING = 'START_FETCHING';
export const startFetching = (text: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: START_FETCHING,
    text
  })
}

export const STOP_FETCHING = 'STOP_FETCHING';
export const stopFetching = (text: string): ThunkAction<void, {}, {}, AnyAction> => (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => State) => {
  dispatch({
    type: STOP_FETCHING,
    text
  })
}